import Validator from "./Validator";

export default class JsonEntitiesEntityDataContent2Validator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'string',
            empty: false,
            mandatory: false
        };
    }
}
